import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a ResizeObserver error
    if (error && error.message && error.message.includes('ResizeObserver')) {
      // Don't update state, just ignore the error
      return null;
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Only log non-ResizeObserver errors
    if (error && error.message && !error.message.includes('ResizeObserver')) {
      console.error('Error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return <div>Algo salió mal. Por favor, recarga la página.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
